export default "__VITE_PUBLIC_ASSET__a2ff00b5__"